<template>
    <div :class="[text ? '' : 'font-italic !important ', 'onlyReadData']">
        {{ text ? text : $t("Не_указано") }}
    </div>
</template>
<script>
export default {
    name: "FieldReadOnly",
    props: {
        text: {
            type: String,
            default: null
        },
    }       
};
</script>

